import { Link } from "react-router-dom";
import { navLinks, siteName, siteIntro, footerLinks } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-md bg-accent-500 text-accent-950 flex items-center justify-center">
                <i className="ri-clapperboard-line text-xl"></i>
              </span>
              <span className="font-heading font-black text-lg text-background-50">{siteName}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-md">{siteIntro}</p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="/"
                aria-label="微博"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-accent-500 hover:text-accent-950 transition-colors cursor-pointer"
              >
                <i className="ri-weibo-fill"></i>
              </a>
              <a
                href="/"
                aria-label="微信"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-accent-500 hover:text-accent-950 transition-colors cursor-pointer"
              >
                <i className="ri-wechat-fill"></i>
              </a>
              <a
                href="/"
                aria-label="哔哩哔哩"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-accent-500 hover:text-accent-950 transition-colors cursor-pointer"
              >
                <i className="ri-bilibili-fill"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4 tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4 tracking-wide">
              帮助与政策
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.map((link, i) => (
                <li key={`${link.label}-${i}`}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © 2026 {siteName} · 本站为影视文化演示站点，作品与人物均为虚构示例
          </p>
          <p className="text-xs text-background-200/60">剧情导航 · 深度解读 · 影视资讯</p>
        </div>
      </div>
    </footer>
  );
}